"use client";
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
import { CardSpaceInset, RadiusSm, ColorGray600, SizeBorderWidthThin, ColorWhite } from "@nxt-costco-com/forge-design-tokens";
const COMPONENT_NAME = "Card";
const Card = styled(Box, {
  // Make sure props are forwarded
  shouldForwardProp: () => true
})(() => ({
  //Styling is currently managed by MuiCostcoTheme
  background: ColorWhite,
  border: "solid",
  borderWidth: SizeBorderWidthThin,
  borderColor: ColorGray600,
  borderRadius: RadiusSm,
  padding: CardSpaceInset
}));
Card.displayName = COMPONENT_NAME;
export {
  Card
};
